import { helper } from '@ember/component/helper';

export default helper(function isEmptyHelper(params) {
  return params.every(p => !p || !('' + p).trim());
});
